import React from 'react';
import { Plus, Bell, Telescope, LayoutGrid, LibraryBig } from 'lucide-react';

interface MobileBottomNavProps {
  onOpenDownloadLibrary: () => void;
  onOpenAddModal: () => void;
  onOpenUpdatedToday: () => void;
  updatedTodayCount: number;
  view: 'tier' | 'discover';
  onChangeView: (view: 'tier' | 'discover') => void;
}

const itemClass = 'flex-1 flex flex-col items-center justify-center gap-1 h-12 rounded-xl transition-colors';

export const MobileBottomNav: React.FC<MobileBottomNavProps> = ({
  onOpenDownloadLibrary,
  onOpenAddModal,
  onOpenUpdatedToday,
  updatedTodayCount,
  view,
  onChangeView,
}) => {
  return (
    <nav className="sm:hidden fixed bottom-0 left-0 right-0 z-40 bg-canvas/85 backdrop-blur-xl border-t border-white/[0.06] px-2 pt-1.5 flex items-center gap-1 safe-area-bottom">
      {/* Tier board */}
      <button
        type="button"
        onClick={() => onChangeView('tier')}
        aria-pressed={view === 'tier'}
        className={`${itemClass} ${view === 'tier' ? 'text-zinc-50' : 'text-zinc-500'}`}
      >
        <LayoutGrid className="w-5 h-5" />
        <span className="text-[10px] font-medium">จัดแรงค์</span>
      </button>

      {/* Download library (sorting lives in the header on phones) */}
      <button type="button" onClick={onOpenDownloadLibrary} className={`${itemClass} text-zinc-500`}>
        <LibraryBig className="w-5 h-5" />
        <span className="text-[10px] font-medium">คลังโหลด</span>
      </button>

      {/* Center Action: Add Manga */}
      <div className="flex-1 flex items-center justify-center">
        <button
          type="button"
          onClick={onOpenAddModal}
          title="เพิ่มมังงะ"
          className="flex items-center justify-center w-12 h-10 bg-zinc-50 text-zinc-900 rounded-xl shadow-lg shadow-black/40 active:scale-95 transition-transform"
        >
          <Plus className="w-5 h-5" strokeWidth={2.25} />
        </button>
      </div>

      {/* Updated Today */}
      <button type="button" onClick={onOpenUpdatedToday} className={`${itemClass} text-zinc-500`}>
        <div className="relative">
          <Bell className="w-5 h-5" />
          {updatedTodayCount > 0 && (
            <span className="absolute -top-1.5 -right-2.5 min-w-[16px] h-4 px-1 bg-rose-500 text-white text-[9px] font-semibold rounded-full leading-4 text-center tabular-nums">
              {updatedTodayCount}
            </span>
          )}
        </div>
        <span className="text-[10px] font-medium">วันนี้</span>
      </button>

      {/* Discover page (its own button; the tier board has the one on the left) */}
      <button
        type="button"
        onClick={() => onChangeView('discover')}
        aria-pressed={view === 'discover'}
        className={`${itemClass} ${view === 'discover' ? 'text-zinc-50' : 'text-zinc-500'}`}
      >
        <Telescope className="w-5 h-5" />
        <span className="text-[10px] font-medium">สำรวจ</span>
      </button>
    </nav>
  );
};
